import {useQuery, gql} from '@apollo/client'
import useRouteBasedSkip from '../../hooks/useRouteBasedSkip'

const QUERY_LONGITUDINAL_SDOH_LIST = gql`
  query longitudinalSdohList {
    longitudinalSdohList {
      SDOH_NAME
      SDOH_KEY
    }
  }
`

/**
 * Query hook for fetching longitudinal SDOH (Social Determinants of Health) list
 * Used by time series components
 */
export function useSdohFilter() {
  const shouldSkip = useRouteBasedSkip('/timeseries')

  const {
    data: sdohFilter,
    loading: loadingSdohFilter,
    refetch: refetchSdohFilter,
    error: errorLoadingSdohFilter
  } = useQuery(QUERY_LONGITUDINAL_SDOH_LIST, {
    context: {clientName: 'longitudinal'},
    notifyOnNetworkStatusChange: true,
    skip: shouldSkip
  })

  return {
    sdohFilter,
    loadingSdohFilter,
    refetchSdohFilter,
    errorLoadingSdohFilter
  }
}
